import { Box } from '@mui/material';
import { ReactNode } from 'react';
import { CommunityPageHeader } from './CommunityPageHeader';

export const CommunityLayout = ({
  children,
  ...p
}: {
  children: ReactNode;
  ownerName: string;
  communityId: number;
  postId?: string;
  influencerId: number;
}) => (
  <Box className="h-full">
    <CommunityPageHeader {...p} />
    {children}
  </Box>
);
